// extracted by mini-css-extract-plugin
module.exports = {"dark":"point_dark__2Zma8","light":"point_light__o8Gsd"};